import React, { ReactElement } from 'react';
import { PushRulesApp } from '@loyalty/push-rules-mfe';
import { Theme } from '@mui/material';
import { WebhookEventTypes } from '@loyalty/shared-common/integration-api-client';
import { colorPalette } from '@qualifio/ui-commons';
import { createStyles, makeStyles } from '@mui/styles';
import { useTranslation } from 'react-i18next';
import { Page, PageBody, PageHeader } from '../../libs/shared/page';
import { TopBar } from '../../libs/shared/layout/TopBar';
import { useAccounts } from '../../libs/accounts/AccountsContext';
import { usePrograms } from '../../libs/loyalty/ProgramsContext';
import { useWebhookEventTypes } from '../../libs/rules/rule-table-constants';

export interface LoyaltyProgram {
  // TODO: Remove when it will be exported from PushRules library
  id: string;
  name: string;
}

export enum Product {
  // TODO: Remove when it will be exported from PushRules library
  loyalty = 'loyalty',
  engage = 'engage',
}

const useStyles = makeStyles<Theme>(({ spacing }) =>
  createStyles({
    body: {
      backgroundColor: colorPalette.grey.light,
      padding: spacing(4),
      '& > div': {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      },
    },
  }),
);

export function PushRulesIndexPage(): ReactElement {
  const classes = useStyles();
  const { programs } = usePrograms();
  const { currentAccount } = useAccounts();
  const { t, i18n } = useTranslation();
  const sourceTranslationWebhookEventType = useWebhookEventTypes();
  return (
    <Page>
      <PageHeader>
        <TopBar />
      </PageHeader>
      <PageBody className={classes.body}>
        <PushRulesApp
          config={{
            product: Product.loyalty,
            lang: i18n.language,
            owner: currentAccount?.id,
            integrationApiUrl: '/api/integration',
            loyalty: {
              programs: programs as LoyaltyProgram[],
              events: Object.values(WebhookEventTypes).map(type => ({
                type,
                name: sourceTranslationWebhookEventType[type],
              })),
            },
          }}
          i18n={i18n}
        />
      </PageBody>
    </Page>
  );
}
